import { CrystalsContent } from './CrystalsContent';

export default CrystalsContent;
